import { render } from "./PopUpEditKanbanTask.vue?vue&type=template&id=af49306e"
import script from "./PopUpEditKanbanTask.vue?vue&type=script&lang=js"
export * from "./PopUpEditKanbanTask.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__